export default {
      id: "ic-circle-close-gray-v2-usage",
      viewBox: "0 0 20 20",
      url: "/" + "images/icons.3.109.2.svg#ic-circle-close-gray-v2-usage",
      toString: function () {
        return this.url;
      }
    }